import { render } from "./J05ChatScreenPanelMessageBody.vue?vue&type=template&id=34c461ce&scoped=true&ts=true"
import script from "./J05ChatScreenPanelMessageBody.vue?vue&type=script&lang=ts"
export * from "./J05ChatScreenPanelMessageBody.vue?vue&type=script&lang=ts"

import "./J05ChatScreenPanelMessageBody.vue?vue&type=style&index=0&id=34c461ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c461ce"]])

export default __exports__